export class AddressDTO
{
    public id? : number;
    public type? : number;
    public streetAddress1? : string;
    public streetAddress2? : string;
    public city? : string;
    public state? : string;
    public zipCode? : string;
    public country? : string;
}